module.exports = __webpack_public_path__ + "img/挣钱明细.2ab04d01.png";